import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { timer } from 'rxjs';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  timerSubscriber;
  currentActive = "Search";

  constructor(private router: Router) { }

  ngOnInit(): void {
    this.timerSubscriber = timer(1000, 1000).subscribe(val => {
      if (this.router.url === '/')
        this.currentActive = "Search";
      else if (this.router.url === '/watchlist')
        this.currentActive = "Watchlist";
      else if (this.router.url === '/portfolio')
        this.currentActive = "Portfolio";
      else
        this.currentActive = "";
    });
  }

  changeRoute(whereTo) {
    switch (whereTo) {
      case "Search":
        this.router.navigate(['/']);
        break;

      case "Watchlist":
        this.router.navigate(['/watchlist']);
        break;

      case "Portfolio":
        this.router.navigate(['/portfolio']);
        break;
    }
  }

}
